import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RegistrationForm } from '../../components/apply/RegistrationForm';
import { ApplyNavbar } from '../../components/apply/ApplyNavbar';

export function ApplyRegisterPage() {
  const navigate = useNavigate();

  const handleSuccess = useCallback((registrationId: string) => {
    navigate(`/apply/success?id=${registrationId}`);
  }, [navigate]);

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg,#180f16 0%,#1e1220 34%,#241525 100%)' }}>
      <ApplyNavbar />
      <div className="page-hero lively">
        <div className="container narrow">
          <span className="badge">活动报名</span>
          <h1>祖孙同唱健康歌 · 报名表</h1>
          <p className="lead">
            请填写祖孙双方基本信息，并上传参赛视频。提交成功后，信息将保存到本地数据文件中，供活动后台查询与统计分析使用。
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container narrow">
          <div className="form-top-note card">
            <div className="note-icon">🎬</div>
            <div>
              <strong>参赛视频说明</strong>
              <p>支持 MP4 / MOV / M4V，建议时长 60–180 秒，单文件建议不超过 220MB。请确保儿童肖像权与展示授权已获得监护人同意。</p>
            </div>
          </div>

          <RegistrationForm onSuccess={handleSuccess} />
        </div>
      </section>
    </div>
  );
}
